import { Component, Vue } from 'vue-property-decorator';
import { Colors, Color } from '@/@types/Color';
import { valueof } from '@/@types/Common';
import { ColorCd } from '@/@types/constant';

@Component
export class ColorCalculator extends Vue {
  static getBackgroundColor(fontColorName: valueof<keyof typeof ColorCd>): {
    rgb: string;
    level: number;
  }[]
  | null {
    let colors: Color[] = [];
    colors = colors.concat(Colors);

    let result = null;
    let selectColor: { colorName: string; colorCode: string };
    let isColorFound: boolean = false;
    colors.forEach((x) => {
      if (x.colorName === fontColorName) {
        selectColor = x;
        isColorFound = true;
      }
    });

    if (isColorFound) {
      const colorRGB: Array<{ rgb: string; level: number }> = [];
      colorRGB.push({
        rgb: 'r',
        level: parseInt(selectColor!.colorCode.substr(0, 2), 16),
      });
      colorRGB.push({
        rgb: 'g',
        level: parseInt(selectColor!.colorCode.substr(2, 2), 16),
      });
      colorRGB.push({
        rgb: 'b',
        level: parseInt(selectColor!.colorCode.substr(4, 2), 16),
      });
      result = colorRGB;
    }
    return result;
  }

  static getBackgroundColorCss(fontColorName: valueof<keyof typeof ColorCd>): string {
    const colorRGB = this.getBackgroundColor(fontColorName);
    if (colorRGB) {
      const r = colorRGB.find((v) => v.rgb === 'r');
      const g = colorRGB.find((v) => v.rgb === 'g');
      const b = colorRGB.find((v) => v.rgb === 'b');
      if (r && g && b) {
        const css = `rgb(${r.level},${g.level},${b.level},0.1)`;
        return css;
      }
    }
    return '';
  }
}
